// /src/Pages/Dashboard/Other/WhatsNew.jsx
import React, { useEffect, useState, useMemo } from 'react';
import '../../../../Stylesheets/Dashboard/Other/WhatsNew.css';
import { motion } from 'framer-motion';
import { FaRocket, FaTools } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { fetchWhatsNew } from '../../../../Redux/Others/WhatsNew/whatsNewSlice';

const WhatsNew = () => {
  const [tab, setTab] = useState('released');
  const dispatch = useDispatch();
  const { released, coming, status } = useSelector((s) => s.whatsNew);

  useEffect(() => {
    if (status === 'idle') dispatch(fetchWhatsNew());
  }, [status, dispatch]);

  const items = useMemo(() => (tab === 'released' ? released : coming), [tab, released, coming]);
  const activeClass = (key) => (tab === key ? 'tab active' : 'tab');

  return (
    <div className="whatsnew-wrapper">
      <h1 className="whatsnew-title">🚀 What’s New in Site360</h1>
      <p className="whatsnew-subtext">Here’s what we’ve launched and what’s coming next!</p>

      <div className="whatsnew-tabs">
        <button className={activeClass('released')} onClick={() => setTab('released')}>🚀 Released</button>
        <button className={activeClass('coming')} onClick={() => setTab('coming')}>🛠 Coming Soon</button>
      </div>

      {status === 'loading' && <div className="feature-grid"><div className="skeleton-card" /></div>}
      {status === 'failed' && <p className="error">Couldn’t load updates. Please retry.</p>}

      {status === 'succeeded' && (
        <motion.div
          className="feature-grid"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          key={tab}
        >
          {items.map((item) => (
            <motion.div className="feature-card" key={item.id}>
              <div className="feature-icon">{tab === 'released' ? <FaRocket /> : <FaTools />}</div>
              <h3>{item.title}</h3>
              {item.date && (
                <p className="feature-date">
                  {new Date(item.date).toLocaleDateString(undefined, {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                  })}
                </p>
              )}
              <p className="feature-desc">{item.desc}</p>
            </motion.div>
          ))}
        </motion.div>
      )}
    </div>
  );
};

export default WhatsNew;
